export default __webpack_public_path__ + "static/media/property_971.a3ba52ba.png";